module.exports = __webpack_public_path__ + "img/user.19138066.png";